const ResourcePhoneActivate = () =>
  import('@/views/main/inspect/resourcePhoneActivate/ResourcePhoneActivate.vue')
export default {
  path: '/main/inspect/resourcePhoneActivate',
  name: 'ResourcePhoneActivate',
  component: ResourcePhoneActivate,
  children: []
}
